export default __webpack_public_path__ + "locales/ru/DeleteThirdPartyDialog.json?hash=2697f639fbbd95c7d74b843813e398d4";